
//import { CoordinateProcessor } from '../../utils/CoordinateProcessor';
import { useMapStore } from "../../store/useMapStore.js";
import { wgs84ToWebMercator } from "../../services/CoordinateTransformService.js";
import { BBOxRelativeToCenter, mercatorRelative } from "../../services/MercatorRelativeToCenter.js";



export class LanduseEntity {
    
    constructor(data = {}) {
        this.id = data.id || '';
        this.landuseType = data.landuseType ||"";
        this.groupName = LanduseEntity.getGroupName(this.landuseType);
        //this.geometry = FlurstuckEntity.wgs84ToWebMercator(data.geometry) || null;
        this.geometry = data.geometry|| null;
        this.mercatorCoordinates=this.geometry.coordinates;
        this.center = useMapStore.getState().center;
        this.type = data.type;
        this.Name = "LanduseEntity";
    }

    // Static method to create multiple entities from raw response
    static fromResponse(response) 
    {
        if (response)
        {
            return response.data.landuseByBounds.landuse
                .filter(entityData => Object.keys(entityData).length !== 0) // remove empty {}
                .map(entityData => new LanduseEntity(entityData));
            
        }
        return [];
    }
     
    static getGroupName(value) {

    const groups = {
        "bauwerke_anlagen": ["turm", "vorratsbehaelterspeicherbauwerk"],
        "gewaesser": ["fliessgewaesser", "stehendesgewaesser"],
        "infrastruktur_verkehr": [
        "bahnverkehr",
        "bahnverkehrsanlage",
        "flugverkehr",
        "hafen",
        "hafenbecken",
        "platz",
        "schiffsverkehr",
        "strassenverkehr"
        ],
        "naturraeume_vegetation": [
        "gehoelz",
        "moor",
        "sumpf",
        "vegetationsmerkmal",
        "wald"
        ],
        "rohstoff_bergbau": ["tagebaugrubesteinbruch"],
        "schutz_recht_festlegung": [
        "denkmalschutzrecht",
        "naturumweltoderbodenschutzrecht",
        "schutzzone"
        ],
        "siedlungs_und_nutzung": [
        "flaechebesondererfunktionalerpraegung",
        "flaechegemischternutzung",
        "friedhof",
        "industrieundgewerbeflaeche",
        "landwirtschaft",
        "sportfreizeitunderholungsflaeche",
        "tatsaechlichenutzung",
        "unlandvegetationsloseflaeche",
        "wohnbauflaeche"
        ]
    };

    // Find the group name that contains the given value
    for (const [group, values] of Object.entries(groups)) {
        if (values.includes(value)) {
        return group;
        }
    }

  return "unknown_group";
}

    
}